import axios from "@/axios/axios";

const actions = {
  async GET_TYPES(context){
    try{
      let {data} = await axios.get('invoices_type');

      context.commit('SET_TYPES', data);
    }
    catch(e){
      context.commit('SET_TYPES', []);
    }
  }
};

export default actions;